import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import { Link, useParams } from "react-router-dom";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { toJalali } from "lib/helpers";

export default function Plans() {
  const { product_id, product_name } = useParams();
  const path = {
    baseRoute: `/products/${product_id}/plans`,
    aliasName: "بیلت ها",
    type: "Plans",
  };

  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    createAndDownload,
    remove,
    listSearch,
    from,
    to,
    meta,
    total,
    getDataList,
  } = useList();
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    dispatch(getDataList(path));

    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <Add
        title="افزودن بلیت"
        show={showAdd}
        tag={"تست"}
        close={() => {
          setShowAdd(false);
        }}
        submit={(values) => {
          dispatch(
            createAndDownload(
              {
                baseRoute: `/products/${product_id}/tickets/`,
                aliasName: "بیلت ها",
                type: "Tickets",
              },
              values,
              () => {
                handleSuccessMessages("بلیت ها  با موفقیت اضافه شد");
                dispatch(getDataList(path));
              }
            )
          );
        }}
      />
      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">
          پلن های {product_name}
        </h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            <button
              onClick={() => {
                setShowAdd(true);
              }}
              className="btn btn-primary shadow-md mr-2"
            >
              افزودن بلیت
            </button>
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">نام</th>
                  <th className="whitespace-nowrap text-center">قیمت</th>
                  <th className="whitespace-nowrap text-center">تعداد کل</th>
                  <th className="whitespace-nowrap text-center">استفاده شده</th>
                  <th className="whitespace-nowrap text-center">مبلغ کل</th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      <td className="text-center">{item?.name}</td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.price}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.count}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.used_count}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.count * item.price}
                        </p>
                      </td>

                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          {item.type == "Tag" && (
                            <Link
                              to={`/tickets/${product_id}/${item?.name}/(${product_name})`}
                            >
                              <a className="flex items-center ml-3 cursor-pointer">
                                <Icons.CreditCard className="w-4 h-4 ml-1" />
                                بلیت ها
                              </a>
                            </Link>
                          )}
                          {item.type == "Cafe" && (
                            <Link
                              to={`/cafe-tickets/${item.id}/${item?.name} (${product_name})`}
                            >
                              <a className="flex items-center ml-3 cursor-pointer">
                                <Icons.CreditCard className="w-4 h-4 ml-1" />
                                بلیت ها
                              </a>
                            </Link>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
